export default __webpack_public_path__ + "static/media/headerBackground.65859583.jpeg";